// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eU5F","content":"styles_content__37AtE","row":"styles_row__31_0G","footer":"styles_footer__2xMlV","phraseLength":"styles_phraseLength__2H8MT"};